export default "__VITE_ASSET__93GWHFJb__$_?url__"